export class CameraPermissionDeniedError extends Error{
    constructor(){
        super("Please reset your browser permission");
    }
}